module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"proceed_to_pay":"Proceed To Pay"},"id":{"proceed_to_pay":"Teruskan ke pembayaran"}}')
  delete Component.options._Ctor
}
